import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { TInput, Toggle, Btn } from "./ui";

const norm = (c) => ({ role: "", name: "", url: null, enabled: true, ...c });

export default function CreditsEditor({ value, onChange }) {
  const credits = Array.isArray(value) ? value : [];
  const setAt = (i, patch) => onChange(credits.map((c, j) => (j === i ? { ...norm(c), ...patch } : c)));
  const remove = (i) => onChange(credits.filter((_, j) => j !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= credits.length) return;
    const next = [...credits];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...credits, { role: "", name: "", url: null, enabled: true }]);

  return (
    <div className="md:col-span-3 border-t border-white/10 pt-4" data-testid="credits-editor">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="font-mono text-[9px] tracking-[0.3em] text-gold">
          CREDITS — ONLY ENABLED ROWS APPEAR PUBLICLY. NEVER INVENT CREDITS.
        </p>
        <Btn variant="ghost" onClick={add} testid="credit-add">
          <span className="inline-flex items-center gap-2"><Plus size={12} /> ADD CREDIT</span>
        </Btn>
      </div>
      {credits.length === 0 && (
        <p className="font-mono text-[9px] tracking-[0.2em] text-white/30 border border-dashed border-white/15 p-4">
          NO CREDITS — THE CREDITS BLOCK IS OMITTED PUBLICLY.
        </p>
      )}
      <div className="space-y-2">
        {credits.map((raw, i) => {
          const c = norm(raw);
          return (
            <div key={i} data-testid={`credit-row-${i}`}
              className="border border-white/10 bg-[#0c0c0c] p-3 grid grid-cols-2 md:grid-cols-12 gap-3 items-end">
              <div className="md:col-span-3">
                <TInput label="ROLE" value={c.role} onChange={(v) => setAt(i, { role: v })}
                  placeholder="Written by" testid={`credit-${i}-role`} />
              </div>
              <div className="md:col-span-3">
                <TInput label="NAME" value={c.name} onChange={(v) => setAt(i, { name: v })} testid={`credit-${i}-name`} />
              </div>
              <div className="md:col-span-3">
                <TInput label="URL (OPTIONAL, HTTPS://…)" value={c.url} onChange={(v) => setAt(i, { url: v || null })}
                  testid={`credit-${i}-url`} />
              </div>
              <div className="md:col-span-3 flex items-center gap-2 pb-1">
                <Toggle label={c.enabled ? "ENABLED" : "DISABLED"} checked={c.enabled}
                  onChange={(v) => setAt(i, { enabled: v })} testid={`credit-${i}-enabled`} />
                <button onClick={() => move(i, -1)} aria-label="Move credit up" data-testid={`credit-${i}-up`}
                  className="text-white/40 hover:text-white px-1"><ArrowUp size={13} /></button>
                <button onClick={() => move(i, 1)} aria-label="Move credit down" data-testid={`credit-${i}-down`}
                  className="text-white/40 hover:text-white px-1"><ArrowDown size={13} /></button>
                <button onClick={() => remove(i)} aria-label="Remove credit" data-testid={`credit-${i}-remove`}
                  className="text-red-400/70 hover:text-red-400 px-1"><Trash2 size={13} /></button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
